export default __webpack_public_path__ + "static/Wiki_Tiles_P-IN-8415WQHD_white-9ad334bfa56469c1e44dae535ba7f493.webp";